import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-button-container',
    templateUrl: './button-container.component.html',
    styleUrls: ['./button-container.component.css'],
    standalone: false
})
export class ButtonContainerComponent {
  @Input() image: string = '';
}
